// src/components/store/sections/faqs/FaqV29BubbleqaFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV29BubbleqaFuchsiaGlow(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={29}
      archKey="bubble_qa"
      archLabel="Chat Bubble Q&A"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
